export interface EncryptedToken {
  token: string;
}
